module.exports = __webpack_public_path__ + "static/media/Shaymin_gaussian2.8ae902e7.png";